import {
  SET_CYCLE,
  SET_USER,
  SET_USERS
} from './mutation-types'
import { login } from '@/api/auth'
import { getCycles } from '@/api/cycle'
import { getAllUsers } from '@/api/user'

export default {
  login ({ commit }) {
    return login()
      .then(user => {
        commit(SET_USER, user)
        return user
      })
  },
  getCycles ({ commit }, defaultCycleId) {
    return getCycles()
      .then(cycles => commit(SET_CYCLE, { cycles, defaultCycleId }))
  },
  getAllUsers ({ commit }) {
    return getAllUsers()
      .then(users => commit(SET_USERS, users.map(user => ({
        ...user,
        mainDepartmentId: {
          id: user.mainDepartmentId[0],
          completeName: user.mainDepartmentId[1]
        }
      }))))
  }
}
